import { memo, ReactElement, useCallback } from 'react';
import { Typography, Button } from 'antd';
import { UserItem, UserInfo, UserControls } from './styles';

const { Text } = Typography;

interface Props {
  id: number;
  name: string;
  email: string;
  isActive: boolean;
  updateIsActive: (userId: number, isActive: boolean) => Promise<void>;
}

const Row = memo(function Row({ id, name, email, isActive, updateIsActive }: Props): ReactElement {
  const handleActivate = useCallback(async () => {
    await updateIsActive(id, true);
  }, [id, updateIsActive]);

  const handleDeactivate = useCallback(async () => {
    await updateIsActive(id, false);
  }, [id, updateIsActive]);

  return (
    <UserItem>
      <UserInfo>
        <Text strong>{name}</Text>
        <Text type='secondary'>{email}</Text>
      </UserInfo>
      <UserControls>
        <Button type='default' size='small' onClick={handleActivate} disabled={isActive}>
          通話 可能
        </Button>
        <Button type='default' size='small' onClick={handleDeactivate} disabled={!isActive}>
          通話 不可
        </Button>
      </UserControls>
    </UserItem>
  );
});

export default Row;
